import React, { PureComponent } from 'react'
import { ActivityIndicator } from 'react-native'

import theme from '../../../styles/theme'

export default class Spinner extends PureComponent {
  render () {
    const { size = 'small', white, colour } = this.props
    let clr = colour || theme.colours.primary
    if (white) {
      clr = theme.colours.white
    }
    return <ActivityIndicator size={size} color={clr} />
  }
}
